// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [{
    key: "AccountNum",
    label: "客户编码",
    sortable: true,
  },
  {
    key: "dataAreaId",
    label: "销售公司",
    sortable: true
  },

  {
    key: "ItemId",
    label: "SEI物料编号",
    sortable: true
  },
  {
    key: "VariantName",
    label: "变型名称",
    sortable: true
  },
  {
    key: "DeliveryDate",
    label: "要求装运日期",
    sortable: true
  },
  {
    key: "SalesQty",
    label: "数量",
    sortable: true,
  },
  {
    key: "SalesPoolId",
    label: "池",
    sortable: true
  },
  {
    key: "SalesLine_TEC_CustSalesID",
    label: "客户订单号",
    sortable: true
  },
  {
    key: "TEC_OtherInfo",
    label: "其他信息",
    sortable: true,
  },
  {
    key: "TEC_CommonRemark",
    label: "通用备注",
    sortable: true
  },
  {
    key: "SEI_PriceUnitCust",
    label: "客户价格",
    sortable: true
  },
  {
    key: "SEI_OrderDateCust",
    label: "客户订单日期",
    sortable: true
  },
  {
    key: "SEI_ShippingDateCust",
    label: "客户交期",
    sortable: true
  },
  ],
  inventTable_fields: [{
    key: "ItemId",
    label: "物料编号",
  },
  {
    key: "NameAlias",
    label: "物料名称",
  },
  {
    key: "DW_InventUnitId",
    label: "单位",
  },

  ],
  cust_fields: [

    {
      key: "AccountNum",
      label: "客户帐户"
    },
    {
      key: "SEI_Name",
      label: "客户名称",
    },
    {
      key: "Currency",
      label: "币种"
    },
    {
      key: "TaxGroup",
      label: "销售税组"
    },
    {
      key: "InclTax",
      label: "价格包括销售税"
    },


  ],
  salesTable_fields: [{
    key: "id",
    label: "编号",
  },
  {
    key: "SalesId",
    label: "销售订单编号"
  },
  {
    key: "CustAccount",
    label: "客户帐户"
  },
  {
    key: "SalesName",
    label: "客户名称",
  },
  {
    key: "InvoiceAccount",
    label: "发票帐户"
  },
  {
    key: "DeliveryDate",
    label: "装运日期",
  },
  {
    key: "CurrencyCode",
    label: "币种"
  },
  {
    key: "TaxGroup",
    label: "销售税组"
  },
  {
    key: "SalesPoolId",
    label: "池"
  },
  {
    key: "InclTax",
    label: "价格包括销售税"
  },
  {
    key: "TEC_Remark",
    label: "备注"
  },
  {
    key: "TEC_FinalCustAccount",
    label: "最终客户"
  },
  {
    key: "dataAreaId",
    label: "公司"
  },
  {
    key: "CompanyName",
    label: "公司名称",
    sortable: true,
    thStyle: { width: "8rem" },
    type: "short"
  },
  ],
}

///前端验证
const rules = {
  CustAccount: [{
    required: true,
    message: "请选择客户账户",
    trigger: "change"
  }],
  TEC_FinalCustAccount: [{
    required: true,
    message: "请选择最终客户",
    trigger: "change"
  }],
  InvoiceAccount: [{
    required: true,
    message: "请选择开票账户",
    trigger: "change"
  }],
  SalesPoolId: [{
    required: true,
    message: "请选择订单池",
    trigger: "change"
  }],
  dataAreaId: [{
    required: true,
    message: "请选择公司",
    trigger: "change"
  }],
  DeliveryDate: [{
    type: "date",
    required: true,
    message: "装运日期",
    trigger: "change"
  }]
  // TEC_Remark: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  //copacking
  async copackingMethod() {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "GenerateCopackingSalesOrder", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {},
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result
    ) {
      return true
    } else {
      return false
    }
  },
  //信用同步
  async pickAndInvoke(params) {
    let query_settings = []
    _.each(params, t => {
      let _p = {
        company: t.dataAreaId,
        tableName: "secp_SEI_CustTable2",
        accountNum: t.accountNum, //不传则查询所有
      }
      query_settings.push({
        url: apiPath.axInterface.pickand_invoke,
        parameters: _p,
        method: "get"
      })
    })

    let data = await api.query_all_async(query_settings)

    if (data) {
      return data[0].result.data[0]
    } else {
      return false
    }
  },
  async SaveSaleOrderExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_salesorder", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#region 订单主档相关
  ///get salesorder
  async getData(_params) {
    let _fields = _.map(fields.default, "key")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save salesorder
  async saveSalesOrder(data) {
    let dataList = _.groupBy(data, "AccountNum")
    let dataForm = {
      id: "",
      SalesId: "", //	销售订单编号
      SalesName: "", //	客户名称
      CustAccount: "", //	客户帐户
      InvoiceAccount: "", //	发票帐户
      DeliveryDate: "", //	装运日期 date
      CurrencyCode: "", //	币种
      TaxGroup: "", //	销售税组
      SalesPoolId: "", //	池
      InclTax: "", //	价格包括销售税
      TEC_Remark: "", //	备注
      TEC_FinalCustAccount: "", //	最终客户
      createdBy: "", //	创建人
      dataAreaId: "" //	公司
    }
    let dataItemForm = {
      id: "",
      SalesTable_id: "",
      SalesId: "", //销售订单
      LineNum: "", //行号
      ItemId: "", //物料编号
      NameAlias: "", //物料名称
      SalesStatus: "", //行状态
      Name: "", //文本
      TaxGroup: "", //销售税组
      QtyOrdered: "", //数量
      RemainSalesPhysical: "", //剩余交货量
      RemainSalesFinancial: "", //未开票数量
      SalesPrice: "", //价格
      DiscPrice: "", //协议价格
      CurrencyCode: "", //币种
      ConfirmedDlv: "", //装运日期
      SalesUnit: "", //单位
      SalesQty: "", //数量
      TaxItemGroup: "", //销售税(物料)组
      UnderDeliveryPct: "", //欠交
      OverDeliveryPct: "", //超交
      RemainInventFinancial: "", //未开票数量
      TEC_CommonRemark: "", //通用备注
      TEC_CustSalesID: "", //客户订单号
      TEC_LineAmountBak: "", //净额
      SEI_OrderDateCust: "", //客户订单日期
      SEI_PriceUnitCust: "", //客户价格
      SEI_ShippingDateCust: "", //客户交期
      dataAreaId: "", //公司
      SEI_ProddataArea: "", //生产商
      valid_remain: "",
      price_approved_state: 0,
      TEC_OtherInfo: ""
    }
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_seq", {}, {}
    )
    const salesTable_biz_data = new biz_data_helper.base_entity_helper(
      "SalesTable", create, descriptor
    )
    const salesLine_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine", create, descriptor
    )
    let _actions = []
    for (var i in dataList) {
      let _new = _.cloneDeep(dataForm)
      _new.SalesName = dataList[i][0].SEI_Name //客户名称
      _new.CustAccount = dataList[i][0].AccountNum //客户账户
      _new.InvoiceAccount = dataList[i][0].AccountNum //发票账户
      _new.DeliveryDate = dataList[i][0].ShippingDateRequested //装运日期
      _new.CurrencyCode = dataList[i][0].CurrencyCode //币种
      _new.TaxGroup = dataList[i][0].TaxGroup //税组
      _new.SalesPoolId = dataList[i][0].SalesType //池
      _new.InclTax = dataList[i][0].InclTax //价格包括销售税
      _new.TEC_FinalCustAccount = dataList[i][0].AccountNum //最终客户
      _new.dataAreaId = dataList[i][0].dataAreaId //公司
      delete _new.id
      //获取code
      let _p = {
        type: "CSO",
        date: _date.format(new Date(), "yyyy-MM-dd")
      }
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "SalesId"
            }
          })
      )
      _actions.push(
        salesTable_biz_data
          .insertAction({
            params: _new,
            fields: ["id"]
          })
          .action({
            output_last_item_map: {
              id: "id"
            },
            mixin_last_item_map: {
              SalesId: "SalesId"
            }
          })
      )
      let dataItems = dataList[i]
      //新增salesLine
      let index = 1
      for (var j in dataItems) {
        let _newLine = _.cloneDeep(dataItemForm)
        _newLine.LineNum = index
        _newLine.ItemId = dataItems[j].ItemId
        _newLine.NameAlias = dataItems[j].NameAlias
        _newLine.TaxGroup = dataItems[j].TaxGroup
        _newLine.SalesPrice = dataItems[j].SalesPrice
        _newLine.DiscPrice = dataItems[j].DiscPrice
        _newLine.CurrencyCode = dataItems[j].CurrencyCode
        _newLine.ConfirmedDlv = dataItems[j].ShippingDateRequested
        _newLine.SalesUnit = dataItems[j].DW_InventUnitId
        _newLine.SalesQty = dataItems[j].SalesQty
        _newLine.TEC_CommonRemark = dataItems[j].TEC_CommonRemark
        _newLine.SEI_OrderDateCust = dataItems[j].SEI_OrderDateCust
        _newLine.SEI_PriceUnitCust = dataItems[j].SEI_PriceUnitCust
        _newLine.SEI_ShippingDateCust = dataItems[j].SEI_ShippingDateCust
        _newLine.dataAreaId = dataItems[j].dataAreaId
        _newLine.valid_remain = dataItems[j].SalesQty
        _newLine.price_approved_state = 0
        delete _newLine.id
        _actions.push(
          salesLine_biz_data
            .insertAction({
              params: _newLine,
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                SalesId: "SalesId",
                SalesTable_id: "id"
              }
            })
        )
        index++
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[2].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[2].Result.Data
    } else {
      return null
    }
  },


  //#endregion

  //#region 订单明细相关
  // 获取客户信息
  async getCustInfo(items) {
    const cust_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_CustTable", create, descriptor
    )
    let custs = []
    _.each(items, t => {
      custs.push(t.AccountNum.toString())
    })
    _
    let result = await cust_biz_data.selectAction({
      params: {
        AccountNum: {
          "in": custs
        },
      },
      fields: _.map(fields.cust_fields, "key")
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //getgetNameAlias 获取物料名称
  async getNameAlias(items) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "InventTable", create, descriptor
    )
    let ItemIds = []
    _.each(items, t => {
      ItemIds.push(t.ItemId.toString())
    })
    let result = await item_biz_data
      .selectAction({
        params: {
          ItemId: {
            "in": ItemIds
          },
        },
        fields: _.map(fields.inventTable_fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get disc 获取价格协议
  async getDiscPrice(items) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_price", {}, {}
    )
    let _actions = []
    _.each(items, t => {
      _actions.push(code_biz_data
        .execAction({
          params: {
            dataAreaId: t.dataAreaId,
            currency: t.currency,
            itemId: t.ItemId,
            accountNum: t.AccountNum,
            qty: t.SalesQty
          }
        })
        .action())
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///get so items
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    // _fields.push("DiscPrice");
    _.remove(_fields, n => {
      return n == "price_state"
    })
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///save so items
  async saveSalesOrderItems(items, soForm) {
    let add_list = [],
      update_list = []

    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        add_list.push(t)
      }
    })

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )

    let so_biz_data = new biz_data_helper.base_entity_helper(
      "SalesTable", {}, {}
    )

    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Approve", {}, {}
    )

    let batch_actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        let _new = _.cloneDeep(dataItemForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        delete _new.id

        batch_actions.push(
          item_biz_data
            .insertAction({
              params: _new,
              fields: ["id"]
            })
            .action({
              output_last_item_map: {
                id: "SalesLine_id"
              }
            })
        )

        ///价格不一致特批
        if (t.SalesPrice != t.DiscPrice) {
          let credit_form = {
            SalesTable_id: soForm.id,
            SalesLine_id: 0,
            type_code: "price", //审批类型：credit：信用额度，price：价格
            CustAccount: soForm.CustAccount,
            SalesName: soForm.SalesName,
            SalesId: soForm.SalesId,
            salesorder_amount: soForm.salesorder_amount,
            valid_credit: soForm.valid_credit,
            SalesPrice: t.SalesPrice,
            DiscPrice: t.DiscPrice
          }
          batch_actions.push(
            so_approve_biz_data
              .insertAction({
                params: credit_form,
                fields: ["id"]
              })
              .action({
                mixin_last_item_map: {
                  SalesLine_id: "SalesLine_id"
                }
              })
          )
        }
      })
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        let _new = _.cloneDeep(dataItemForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        batch_actions.push(
          item_biz_data
            .updateAction({
              params: _new,
              fields: ["id"]
            })
            .action({})
        )

        ///价格不一致特批
        if (t.SalesPrice != t.DiscPrice) {
          let credit_form = {
            SalesTable_id: soForm.id,
            SalesLine_id: t.id,
            type_code: "price", //审批类型：credit：信用额度，price：价格
            CustAccount: soForm.CustAccount,
            SalesName: soForm.SalesName,
            SalesId: soForm.SalesId,
            salesorder_amount: soForm.salesorder_amount,
            valid_credit: soForm.valid_credit,
            SalesPrice: t.SalesPrice,
            DiscPrice: t.DiscPrice
          }
          batch_actions.push(
            so_approve_biz_data
              .insertAction({
                params: credit_form,
                fields: ["id"]
              })
              .action({})
          )
        }
      })
    }

    ///修改订单信用控制状态
    if (soForm) {
      batch_actions.push(
        so_biz_data
          .updateAction({
            params: {
              id: soForm.id,
              credit_control_state: soForm.credit_control_state
            },
            fields: ["id"]
          })
          .action({})
      )
    }

    ///信用额度特批
    if (soForm && soForm.credit_control_state == 1) {
      let credit_form = {
        SalesTable_id: soForm.id,
        SalesLine_id: 0,
        type_code: "credit", //审批类型：credit：信用额度，price：价格
        CustAccount: soForm.CustAccount,
        SalesName: soForm.SalesName,
        SalesId: soForm.SalesId,
        salesorder_amount: soForm.salesorder_amount,
        valid_credit: soForm.valid_credit
        // SalesPrice: 0,
        // DiscPrice: 0
      }
      batch_actions.push(
        so_approve_biz_data
          .insertAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({})
      )
    }

    let result = await api.query_batch({
      actions: batch_actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },

  ///del so items
  async deleteItemData(items) {
    let _actions = []

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )

    _.each(items, t => {
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
  //#endregion
}
export {
  biz_data, fields,
  methods,
  rules
};

